<template>
  <div>
    <div id="status"></div>
    <button class="button" @click="logInWithFacebook">
      Login with Facebook
    </button>
    <!-- <fb:login-button scope="public_profile,email" onlogin="checkLoginState();">
    </fb:login-button> -->
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "FacebookLoginBtn",
  methods: {
    ...mapActions("account", ["socialLogin"]),
    checkLoginState() {
      window.FB.getLoginStatus(response => {
        this.statusChangeCallback(response);
      });
    },
    statusChangeCallback(response) {
      if (response.status === "connected") {
        // Logged into your webpage and Facebook.
        // testAPI();
        // window.FB.api("/me", function(response) {
        // document.getElementById("status").innerHTML =
        //   "Thanks for logging in, " + response.name + "!";
        // });
      } else {
        // Not logged into your webpage or we are unable to tell.
        document.getElementById("status").innerHTML =
          "Please log " + "into this webpage.";
      }
    },
    async logInWithFacebook() {
      let self = this;
      await this.loadFacebookSDK(document, "script", "facebook-jssdk");
      await this.initFacebook();
      window.FB.login(
        function(response) {
          let accessToken = response?.authResponse?.accessToken;
          if (accessToken) {
            self.socialLogin({ provider: "facebook", token: accessToken });
          } else {
            console.log("error");
          }
        },
        { scope: "email" }
      );
      return false;
    },
    async initFacebook() {
      window.fbAsyncInit = () => {
        window.FB.init({
          appId: "317702152916910", //You will need to change this
          cookie: true, // This is important, it's not enabled by default
          xfbml: true,
          version: "v8.0"
        });
        window.FB.getLoginStatus(response => {
          // Called after the JS SDK has been initialized.
          this.statusChangeCallback(response); // Returns the login status.
        });
      };
    },
    async loadFacebookSDK(d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }
  },
  async created() {
    await this.loadFacebookSDK(document, "script", "facebook-jssdk");
    await this.initFacebook();
    this.checkLoginState();
  }
};
</script>
<style>
.button {
  color: white;
  min-width: 150px;
  background-color: #000000a1;
  height: 2.5rem;
  border-radius: 2rem;
  font-weight: 400;
  font-size: 0.8rem;
}
</style>
